import React from 'react';

import { FlexLayout } from '@swyftx/aviary/atoms/Layout/Flex';
import { MarginOrderDirection, MarginOrderType, ProtectionOrderVariant } from '@swyftx/margin/build/types';

import { Asset } from '@shared/api';
import { formatCurrency } from '@shared/utils';

import { MarginLotsInput, MarginPriceInput } from '@routes/SwyftxMargin/components/General';

import { useMarginInstruments } from 'src/lib/margin/hooks/instruments';
import { useMarginTradePanelStoreUtils } from 'src/lib/margin/hooks/trade';

import { MarginTradePanelProtectionOrder } from '../MarginTradePanelProtectionOrder/MarginTradePanelProtectionOrder';

type Props = {
  tradeType: MarginOrderType;
  tradeSide: MarginOrderDirection;
  asset: Asset;
};

const MarginTradePanelContent: React.FC<Props> = ({ tradeType, tradeSide, asset }) => {
  const { selectedMarket } = useMarginInstruments();
  const { maxMarginPosition, onUpdateTradeLots, lots, price, audPrice, inversePrice, onUpdateTradePrice } =
    useMarginTradePanelStoreUtils({
      tradeSide,
    });

  if (!selectedMarket) return null;

  return (
    <FlexLayout direction='column' className='w-full px-12 py-12' spacing={12}>
      <MarginPriceInput
        tradeType={tradeType}
        tradeSide={tradeSide}
        price={price}
        onChange={onUpdateTradePrice}
        market={selectedMarket}
        disabled={tradeType === MarginOrderType.Market}
      />
      <MarginLotsInput
        market={selectedMarket}
        asset={asset}
        lots={lots}
        maxMarginPosition={maxMarginPosition}
        price={audPrice.toString()}
        onChange={onUpdateTradeLots}
      />
      <FlexLayout direction='column' spacing={8} className='pb-16'>
        <MarginTradePanelProtectionOrder
          tradeSide={tradeSide}
          tradeType={tradeType}
          protectionOrderType={ProtectionOrderVariant.StopLoss}
          placeholder={formatCurrency(inversePrice, undefined, { priceScale: selectedMarket.precision })}
        />
        <MarginTradePanelProtectionOrder
          tradeSide={tradeSide}
          tradeType={tradeType}
          protectionOrderType={ProtectionOrderVariant.TakeProfit}
          placeholder={formatCurrency(inversePrice, undefined, { priceScale: selectedMarket.precision })}
        />
      </FlexLayout>
    </FlexLayout>
  );
};

export { MarginTradePanelContent };
